import React from "react";
import JsonDiffPatch from "components/JsonDiffPatch";
import Inspector from "react-json-inspector";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse
} from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

// import PropTypes from "prop-types";
import InboxIcon from "@material-ui/icons/Inbox";
import { colors, errorDivStyle } from "./UploadCommon";
// These are errors/warnings returned when a test insert is done on the DB
// Can be errors or warnings. Eg of a warning is Duplicate ID

export default class DatabaseErrors extends React.Component {
  state = { collapse: new Set() };

  handleClick = i => () => {
    if (this.state.collapse.has(i)) {
      this.state.collapse.delete(i);
      this.setState({ collapse: new Set(this.state.collapse) });
    } else this.setState({ collapse: this.state.collapse.add(i) });
  };

  render() {
    const { props } = this;

    const removeEmpties = obj => {
      const out = {};
      Object.entries(obj).forEach(([key, val]) => {
        if (
          val &&
          !["submission_id", "pk"].includes(key) &&
          val !== "Unknown"
        ) {
          if (typeof val === "object") {
            if (Object.keys(val).length) out[key] = val;
          } else out[key] = val;
        }
      });
      return out;
    };

    if (!props.rows.some(row => row.level.toLowerCase() === props.level))
      return null;

    return (
      <div
        style={{
          ...errorDivStyle,
          borderColor: colors[props.level]
        }}
      >
        <List>
          {props.rows
            .filter(row => row.level.toLowerCase() === props.level)
            .map((row, i) => {
              let hasOldRowAndNewRow = false;
              let oldRowJson = {};
              let newRowJson = {};
              if (row.report) {
                hasOldRowAndNewRow = Boolean(
                  row.report.old_row && row.report.new_row
                );
                oldRowJson = row.report.old_row;
                newRowJson = row.report.new_row;
              }

              const { detail, ...dataWithoutDetail } = row;
              const nested = [];
              if (hasOldRowAndNewRow) {
                nested.push(
                  <div style={{ marginTop: "10px", marginLeft: "50px" }}>
                    The following changes would be made to the database:
                    <JsonDiffPatch left={oldRowJson} right={newRowJson} />
                  </div>
                );
              }
              // else if (newRowJson && row.report) {
              //   nested.push(
              //     <Inspector
              //       data={newRowJson}
              //       search={false}
              //       isExpanded={() => true}
              //     />
              //   );
              // }
              else {
                nested.push(
                  <Inspector
                    data={removeEmpties(dataWithoutDetail)}
                    search={false}
                    isExpanded={() => true}
                  />
                );
              }

              return (
                <div>
                  <ListItem button onClick={this.handleClick(i)}>
                    <ListItemIcon>
                      <InboxIcon />
                    </ListItemIcon>
                    <ListItemText
                      inset
                      primary={[row.message, row.hint]
                        .filter(e => e)
                        .join(". ")}
                    />
                    {this.state.collapse.has(i) ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </ListItem>

                  <Collapse
                    in={this.state.collapse.has(i)}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List
                      component="div"
                      disablePadding
                      disableGutters
                      style={{ backgroundColor: "transparent" }}
                    >
                      <ListItem>
                        <ListItemText inset primary={nested} />
                      </ListItem>
                    </List>
                  </Collapse>
                </div>
              );
            })}
        </List>
      </div>
    );
  }
}
